import { useApiQuery } from './useApiQuery'

/**
 * Hook para obtener métricas del dashboard de orientador
 * Consume GET /api/v5/metrics/counselor-dashboard
 */
export const useCounselorMetrics = () => {
  const query = useApiQuery(
    ['counselor-metrics'],
    'schools',
    '/metrics/counselor-dashboard',
    {},
    { authenticated: true, version: 5 }
  )

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch
  }
}
